import { InvoiceableRepository } from '@/modules/facturae/domain/InvoiceableRepository'
import { InvoiceListScreenData } from '../domain/InvoiceListScreenData'
import { FileRepository } from '@/modules/shared/domain/FileRepository'
import { Invoiceable } from '../domain/Invoiceable'
import { ConfigurationRepository } from '../domain/ConfigurationRepository'
import { Configuration } from '../domain/Configuration'
import { isConfigurationOK, isInvoiceIncomplete} from '@/modules/facturae/domain/InvoiceableValidation'
import { Sequence } from '../domain/Sequence'

import { DownloadEInvoicesExcelCommand } from "@/modules/facturae/app/DownloadEInvoicesExcelCommand";


export class InvoiceListComponent {

    invoice_repo: InvoiceableRepository
    screen_data: InvoiceListScreenData
    config_repo: ConfigurationRepository
    file_repo: FileRepository
    invoiceable_type: string
    feature_repo: any

    constructor(invoice_repo, screen_data, config_repo, file_repo, invoiceable_type, feature_repo) {
        this.invoice_repo = invoice_repo
        this.screen_data = screen_data
        this.config_repo = config_repo
        this.file_repo = file_repo
        this.invoiceable_type = invoiceable_type
        this.feature_repo = feature_repo
    }

    async mountList(company_id: Number) {
        this.screen_data.setLoading(true)
        let args = {}
        args['company_id'] = company_id
        args['limit'] = this.screen_data.limit
        args['offset'] = this.screen_data.offset
        args['filters'] = {'type': this.invoiceable_type}
        args['order_by'] = this.screen_data.sort_by
        Object.values(this.screen_data.availableFilters).forEach(element => {
            if (element.name === 'info_third') {
                args['info_third'] = element.value;
            } else if (
                typeof element.value === 'boolean' || 
                (element.value !== '' && element.value !== null && element.value !== undefined && element.value !== 0)
            ) {
                args['filters'][element.name] = element.value;
            }
        });
        let res = await this.invoice_repo.filter_invoices(args)
        let invoiceable_id_list = await this.invoice_repo.get_invoiceable_id_list(args)
        this.screen_data.invoiceableIdList = invoiceable_id_list
        this.screen_data.setInvoices(res.results)
        this.screen_data.setTotalItems(res.count)
        this.screen_data.setLoading(false)
        this.screen_data.selectedItems = []
    }

    updateFilters(params) {
        if (params.key === 'id' && params.value !== null && params.value !== undefined) { // for 'id' filter, trim value + ensure it's digits-only
            params.value = params.value.trim()
            params.value = params.value.match(/^[0-9]+$/) ? params.value : null
        }
        Object.values(this.screen_data.availableFilters).forEach(element => {
            if (params.key === element.name) {
                element.value = params.value;
                element.text = params.text;
            }
        });
    }

    celanAllFilters() {
        Object.values(this.screen_data.availableFilters).forEach(element => {
            element.value = '';
            element.text = '';
        });
        this.screen_data.offset = 0
    }

    // async downloadRegistredInvoices() {
    //     this.screen_data.setLoadinDownload(true)
    //     await this.invoice_repo.download_registred_invoices()
    //     this.screen_data.setLoadinDownload(false)
    // }

    async downloadZipFile(s_url){
        const response = await fetch(s_url)
        if (!response.ok || response.type === 'opaque') {
            throw new Error('Error al descargar zip');
        }
        const blob = await response.blob();
        const url = await URL.createObjectURL(blob)
        const a = document.createElement("a");
        a.href = url;
        let ext = 'zip'
        a.download = this.screen_data.invoiceableTypeName+ '_zip_' + new Date().toISOString().replace(/T/, '_').replace(/\..+/, '') + '.' + ext;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    async download_pdf_invoices(){
        try {
            this.screen_data.asyncJobState = 'running';
            let inv_ids = this.screen_data.selectedItems.map(item => item['id'])
            let res = null
            res = await this.invoice_repo.download_pdfs(inv_ids)
            await this.downloadZipFile(res.url)
            this.screen_data.asyncJobState = 'done';
        } catch (e) {
            console.log(e)
            this.screen_data.error_message('Error en la descarga')
        }
        
    }
    async downloadExcelInvoices() {
        let inv_ids = this.screen_data.selectedItems.map(item => item['id'])
        let cmd = new DownloadEInvoicesExcelCommand(this.screen_data)
        this.screen_data.loadingExcelDownload = true
        let cmd_output = await cmd.run(inv_ids)
        this.screen_data.loadingExcelDownload = false
        if (typeof cmd_output === "object") {
            if (!cmd_output) {
                this.screen_data.error_message('Error en la descarga') // "La consulta no ha devuelto ningún resultado."
            }
            else {
                this.screen_data.error_message = cmd_output["error"]
            }
        }
        else if (typeof cmd_output === "string") {
            this.download_from_url(cmd_output)
        }
    }
    async download_from_url(url) {
        const res = await fetch(url);
        const blob = await res.blob();

        const objUrl = window.URL.createObjectURL(new Blob([blob])); // Link pointing to the ObjectURL containing the blob.
        const link = document.createElement("a");
        
        link.href = objUrl;
        link.download = "Facturas.xlsx";
        link.click();

        setTimeout(() => { window.URL.revokeObjectURL(objUrl); }, 250); // For Firefox it is necessary to delay revoking the ObjectURL
    }
    async deleteSelectedItems() {
        this.screen_data.setLoading(true)
        let selected_ids = this.screen_data.selectedItems.map(item => item['id'])
        let res = await this.invoice_repo.delete_selected_items(selected_ids)
        this.screen_data.selectedItems = []
        if (res){
            this.screen_data.success_message('Facturas eliminadas')
        }
        else{
            this.screen_data.error_message('Error al eliminar facturas')
        }
        this.screen_data.setLoading(false)
    }

    async fetchConfiguration(company_id) {
        let config = await this.config_repo.get_configuration(Number(company_id), this.invoiceable_type)
        if (config) {
            this.screen_data.configuration = config
            // return
        }
        else {
            this.screen_data.configuration = new Configuration()

            this.screen_data.configuration.company_id = Number(company_id)
            this.screen_data.configuration.sequences[0].company_id = Number(company_id)
        }
        this.screen_data.dirtyUploadedLogo = false

        // Load templates
        try {
            this.screen_data.templates = await this.config_repo.get_templates(Number(company_id))
        } catch (error) {
            console.error('Error loading templates:', error)
            this.screen_data.templates = []
        }
    }

    async saveConfiguration() {
        // this.screen_data.setLoading(true)
        if (this.screen_data.dirtyUploadedLogo) {
            if (this.screen_data.file) {
                let res_upload = await this.file_repo.uploadFile(this.screen_data.file)
                if (res_upload) {
                    this.screen_data.configuration.path = res_upload
                } else {
                    this.screen_data.error_message('Error al subir logo')
                    this.screen_data.setLoading(false)
                    return
                }
            } else {
                this.screen_data.configuration.path = null
                this.screen_data.configuration.path_url = ''
            }
        }
        try {
            let res = await this.config_repo.save_configuration(this.screen_data.configuration, this.invoiceable_type)
            this.screen_data.asyncJobState = 'running';
            this.screen_data.asyncJobId = res.job_id;

            // Reload templates after saving to reflect any newly created templates
            try {
                this.screen_data.templates = await this.config_repo.get_templates(Number(this.screen_data.companydb_id))
            } catch (error) {
                console.error('Error reloading templates:', error)
            }
        }
        catch (error) {
            console.error('Error save company configuration', error)
        }
    }

    async createRectificative() {
        this.screen_data.setLoading(true)
        let original_invoice = null
        if (this.screen_data.selectedItems.length > 0) {
            original_invoice = await this.invoice_repo.find_by_id(this.screen_data.selectedItems[0]['id'])
        }
        this.screen_data.new_invoice = this.screen_data.new_invoice.createRectificativeFromOriginal(original_invoice, this.screen_data.externalRecInvNumber, this.screen_data.externalRecInvDate, this.screen_data.configuration)
        this.screen_data.new_invoice.compute()
        let res = await this.invoice_repo.save(this.screen_data.new_invoice)
        return res
    }

    async duplicateAsDraft() {
        let ids = this.screen_data.selectedItems.map(item => item['id'])
        let some_rectificative = this.screen_data.selectedItems.some(item => item['rectificative'] === true)
        if (some_rectificative) {
            this.screen_data.error_message('No se puede duplicar una factura rectificativa')
            return false
        }
        if (ids.length == 0) {
            this.screen_data.error_message('Para duplicar debe seleccionar al menos un elemento del listado')
            return false
        }
        this.screen_data.setLoading(true)
        let res = await this.invoice_repo.duplicate_as_draft(ids)
        this.screen_data.setLoading(false)
        if (res) {
            let msg = this.invoiceable_type == 'delivery_note' ? 'Albaranes' : this.invoiceable_type == 'budget' ? 'Presupuestos' : 'Facturas'
            this.screen_data.success_message(msg + ' duplicadas con éxito')
            return true
        }
        else {
            let msg = this.invoiceable_type == 'delivery_note' ? 'albaranes' : this.invoiceable_type == 'budget' ? 'presupuestos' : 'facturas'
            this.screen_data.error_message('Error al duplicar ' + msg)
            return false
        }
    }

    async sendToAccounting() {
        try{
            let ids = this.screen_data.selectedItems.map(item => item['id'])
            if (ids.length == 0) {
                this.screen_data.error_message('Para enviar facturas al módulo de contabilidad debe seleccionar al menos un elemento del listado')
                return false
            }
            let res = null
            res = await this.invoice_repo.send_to_accounting(ids)
            this.screen_data.asyncJobState = 'running'
            this.screen_data.asyncJobId = res.job_id
        } catch(e){
            this.screen_data.error_message("Error en el envío de las facturas al módulo de contabilidad")
        }
    }

    async generateInvoiceFromInvoiceable(order_by_invoice_number){
        // console.log(this.screen_data.mergeDeliveryNotesSelected)
        let res = await this.invoice_repo.generate_invoice_from_invoiceable(this.screen_data.mergeDeliveryNotesSelected, order_by_invoice_number) // s'envien ids i si volem o no seguir un ordre.
        this.screen_data.setLoading(false)
        this.screen_data.mergeDeliveryNotesMode = ''
        if (res) {
            this.screen_data.success_message('Facturas generadas con éxito')
            return true
        }
        else {
            this.screen_data.error_message('Error al generar facturas')
            return false
        }
    }

    async generateRemittance() {
        let ids = this.screen_data.selectedItems.map(item => item['id'])
        this.screen_data.setLoading(true)
        let res = await this.invoice_repo.generate_remitance(ids, this.screen_data.selectedRemittanceType)
        this.screen_data.setLoading(false)
        console.log(res)

        if (res && !res.error){
            // Create a Blob from the XML string
            let xmlString = res.xml
            const blob = new Blob([xmlString], { type: 'application/xml' });

            // Create a download link
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            let uuid = res.remittance_uuid
            link.download = 'remesa_'+uuid+'.xml';
            link.click();

            // Clean up the URL object
            URL.revokeObjectURL(link.href);
            this.screen_data.success_message('Remesa generada con éxito')
        }

        this.screen_data.selectedItems = []
        return res
    }
    async companyHasActiveEinvoiceContract(company_id) {        
        this.screen_data.hasActiveContract = await this.invoice_repo.company_has_active_einvoice_contract(company_id)        
    }

    async massiveSendViaEmail() { 
        let ids = this.screen_data.selectedItems.map(item => item['id'])
        if (ids.length == 0) {
            this.screen_data.error_message('Para enviar por email debe seleccionar al menos una factura')
            return
        }
        let some_draft = this.screen_data.selectedItems.some(item => item['state'] === 'draft')
        if (some_draft) {
            this.screen_data.error_message('No se pueden enviar facturas en estado borrador')
            return
        }
        if (this.screen_data.configuration.email_template
            && (this.screen_data.configuration.email_template.message == ''
            || this.screen_data.configuration.email_template.subject == '')) {
            this.screen_data.error_message('Debe configurar una plantilla de email para poder eviar facturas')
            return
        }
        this.screen_data.setLoading(true)
        try {
            let res = await this.invoice_repo.massive_send_via_email(ids, this.screen_data.companydb_id, this.screen_data.configuration.email_template)
            let msg = this.invoiceable_type == 'delivery_note' ? 'albaranes' : this.invoiceable_type == 'budget' ? 'presupuestos' : 'facturas'

            // Si hay errores, mostrarlos
            if (res && Object.keys(res).length > 0) {
                let errorMessages = Object.entries(res).map(([inv_id, error]) => {
                    return `Factura ${inv_id}: ${error}`
                }).join('\n')
                this.screen_data.error_message(`Error al enviar ${msg}:\n${errorMessages}`)
                return { success: false, message: errorMessages }
            } else {
                let successMessage = `${msg.charAt(0).toUpperCase() + msg.slice(1)} enviadas por correo con éxito`
                return { success: true, message: successMessage }
            }
        } catch (error) {
            console.error('Error enviando facturas por correo:', error)
            return { success: false, message: 'Error enviando facturas por correo' }
        } finally {
            this.screen_data.setLoading(false)
        }
    }

    async massiveDueDate(){
        console.log("Añadición masiva due date")
        this.screen_data.setLoading(true)
        let res;
        
        const items = this.screen_data.selectedItems as any[] // Obtención de las facturas seleccionadas

        if (items.length === 0) {
            this.screen_data.setLoading(false)
            return { error: true, message: 'Selecciona al menos una factura para añadir la fecha de vencimiento.' }
        }
        
        const nonDraft = items.filter(i => i.state?.trim().toLowerCase() !== 'draft')
        if (nonDraft.length > 0) {
            const nonDraftIds = nonDraft.map(i => i.id).join(', ')
            this.screen_data.setLoading(false)
            return { 
                error: true, 
                message: `No se pueden modificar facturas que no estén en estado "Borrador".<br> Las facturas con los siguientes Id no están en borrador: ${nonDraftIds}.` 
            }
        }

        const ids = items.map(i => i.id)

        // Comprobamos que la fecha de vencimiento no es para ninguna factura anterior a su fecha de factura (de las que vayamos a modificar, es decir hace falta que no tengan fecha de vencimiento ya escrita). Notificaríamos y pararíamos.
        const badDueDate: number[] = []
        for (const item of items){
            if (!item.invoice_due_date && new Date(item.invoice_date) > new Date(this.screen_data.dueDate)){
                badDueDate.push(item.id)
            }
        }
        if (badDueDate.length) {
            let msg = ''
            msg += `La fecha de vencimiento propuesta es anterior a la fecha de factura para las facturas con Id: ${badDueDate.join(', ')}. <br>`
            this.screen_data.setLoading(false)
            return { error: true, message: msg.trim() }
        }

        //hacemos la añadición masiva
        try {
            res = await this.invoice_repo.massive_due_date(ids, this.screen_data.dueDate)
            // this.screen_data.asyncJobState = 'running'
            // this.screen_data.asyncJobId = res.job_id
            //return { error: false, job_id: res.job_id, success: true}
            return {res:res, success:true, message:' Se ha añadido correctamente la fecha de vencimiento', error:false}
        } catch (e) {
            return { error: true, message: 'No se ha podido añadir la fecha de vencimiento correctamente' }
        } finally {
            this.screen_data.setLoading(false)
        } 
    }

    async massivePaymentMeans(){
        this.screen_data.setLoading(true)
        let res;
        console.log("Añadición masiva payment_means")

        const items = this.screen_data.selectedItems as any[] //Obtención de las facturas seleccionadas
        
        if (items.length === 0) {
            this.screen_data.setLoading(false)
            return { error: true, message: 'Selecciona al menos una factura para añadir el método de pago.' }
        }
        
        const nonDraft = items.filter(i => i.state?.trim().toLowerCase() !== 'draft')
        if (nonDraft.length > 0) {
            const nonDraftIds = nonDraft.map(i => i.id).join(', ')
            this.screen_data.setLoading(false)
            return { 
                error: true, 
                message: `No se pueden modificar facturas que no estén en estado "Borrador".<br> Las facturas con los siguientes Id no están en borrador: ${nonDraftIds}.` 
            }
        }

        const ids = items.map(i => i.id)

        try {
            res = await this.invoice_repo.massive_payment_means(ids, this.screen_data.paymentMeans)
            // this.screen_data.asyncJobState = 'running'
            // this.screen_data.asyncJobId = res.job_id
            //return { error: false, job_id: res.job_id, success: true}
            return {res:res, success:true, message:' Se ha añadido correctamente el método de pago', error:false}
        } catch (e) {
            return { error: true, message: 'No se ha podido añadir el método de pago correctamente' }
        } finally {
            this.screen_data.setLoading(false)
        }   
    }
    
    async massivePaymentMeansDueDate(){
        console.log("Añadición masiva payment means + due date")
        this.screen_data.setLoading(true)
        let res;
        
        const items = this.screen_data.selectedItems as any[]

        if (items.length === 0) {
            this.screen_data.setLoading(false)
            return { error: true, message: 'Selecciona al menos una factura para añadir la fecha de vencimiento.' }
        }
        
        const nonDraft = items.filter(i => i.state?.trim().toLowerCase() !== 'draft')
        if (nonDraft.length > 0) {
            const nonDraftIds = nonDraft.map(i => i.id).join(', ')
            this.screen_data.setLoading(false)
            return { 
                error: true, 
                message: `No se pueden modificar facturas que no estén en estado "Borrador".<br> Las facturas con los siguientes Id no están en borrador: ${nonDraftIds}.` 
            }
        }

        const ids = items.map(i => i.id)

        const badDueDate: number[] = []
        for (const item of items){
            if (item.invoice_due_date && new Date(item.invoice_date) > new Date(this.screen_data.dueDate)){
                badDueDate.push(item.id)
            }
        }
        if (badDueDate.length) {
            let msg = ''
            msg += `La fecha de vencimiento propuesta es anterior a la fecha de factura para las facturas con Id: ${badDueDate.join(', ')}. <br>`
            this.screen_data.setLoading(false)
            return { error: true, message: msg.trim() }
        }

        try {
            res = await this.invoice_repo.massive_payment_means_due_date(ids, this.screen_data.paymentMeans, this.screen_data.dueDate)
            if (!res.error){
                return { error: false, job_id: res.job_id, success: true}
            } 
            else{
                return { error: true, job_id: res.job_id, success: true, message:'No se ha podido añadir massivamente el método de pago + la fecha de vencimiento.'}
            }
        } catch (e) {
            return { error: true, message: 'No se han podido añadir el método de pago y fecha de vencimiento.' }
        } finally {
            this.screen_data.setLoading(false)
        } 



    }

    async massiveSign(){        
        this.screen_data.setLoading(true)
        let res;

        //0.- Obtención de las facturas seleccionadas
        const rawItems = this.screen_data.selectedItems as any[] //poso as any[] pq si no me diu que item(object) no té invoice_date, p.ex.

        //1.- Las ordenamos por ID (ya que invoice_date se setea al firmar, no antes)
         const items = [...rawItems].sort((a, b) => {
            return a.id - b.id
        })
        
        //2.- Si no hay ninguna seleccionada
        if (items.length === 0) {
            this.screen_data.setLoading(false)
            return { error: true, message: 'Para firmar y emitir masivamente debe seleccionar al menos una factura' }
        }

        //3.- Comprobamos que las facturas seleccionadas sean válidas para firmar y emitir.
        // listas para almacenar fallos
        const badDraft: number[] = []
        const badConfig: number[] = []
        const badIncomplete: number[] = []
        const badIncompleteErrors: { [key: number]: string[] } = {}
        // si están incompletas por Fecha de Vencimiento o Método de pago (Gaudium)
        const badDueDate: number[] = []
        const badPaymentMeans: number[] = []

        //obtenció de seqüències:
        const sequences: Sequence[] =  this.screen_data.configuration.sequences 
        //sequence per id:
        const sequencesById = sequences.reduce<Record<number, Sequence>>((map, seq) => {
            map[seq.id] = seq
            return map
            }, {}
        )
        //com hem ordenat items(factures) l'obtenció dels ids dels items és ordenada.
        const ids = items.map(i => i.id)
        
        for (const inv_id of ids){ //recorremos sus ids y obtenemos las facturas desde el backend, pues en el listado del frontend, de cada factura solo aparecen los datos relevantes. 
            
            const inv = await this.invoice_repo.find_by_id(inv_id)
            //preparacions
            const seq = sequencesById[inv.sequence_id]
            const label = inv.id //per a retornar quines erren
            
            //comprovacions
            if (!seq) {
                badConfig.push(label)
            }
            if(inv.state!="draft"){
                badDraft.push(label)
            }
            if (!isConfigurationOK(inv, seq, sequences, this.invoiceable_type)){
                badConfig.push(label)
            }
            const validationResult = isInvoiceIncomplete(
                inv,
                seq,
                this.invoiceable_type,
                this.feature_repo.got_feature('feature_facturae_allow_lines_at_zero'),
                this.feature_repo.got_feature('feature_invoice_date_editable')
            );
            if (validationResult.isIncomplete){
                badIncomplete.push(label)
                if (validationResult.errors && validationResult.errors.length) {
                    badIncompleteErrors[label] = validationResult.errors
                }
            }
            //si es incompleta debido a la falta de fecha de factura o método de pago lo marcamos para luego proponer una añadición masiva
            if (inv.payment_means=='' || inv.payment_means=='00'){
                badPaymentMeans.push(label)
            }
            if (!inv.invoice_due_date){
                badDueDate.push(label)
            }
        }

        // 4) Si hi ha error, notifiquem i parem

        if (badPaymentMeans.length || badDueDate.length){
            let msg = ''
            if (badPaymentMeans.length){
                msg += `Las siguientes facturas no tienen método de pago: ${badPaymentMeans.join(', ')}. <br>`
            }
            if (badDueDate.length){
                msg += `Las siguientes facturas no tienen fecha de vencimiento: ${badDueDate.join(', ')}. <br>`
            }
            this.screen_data.setLoading(false)
            return { error: true, message: msg.trim(), badPaymentMeans, badDueDate}
        }else if (badConfig.length || badIncomplete.length || badDraft.length) {
            let msg = ''
            if (badDraft.length) {
                msg += `Las siguientes facturas no son borradores: ${badDraft.join(', ')}. <br>`
            }
            if (badConfig.length) {
                msg += `Las siguientes facturas tienen una configuración inválida: ${badConfig.join(', ')}. <br>`
            }
            if (badIncomplete.length) {
                const detailedIncomplete = badIncomplete.map((id) => {
                    const errors = badIncompleteErrors[id]
                    if (errors && errors.length) {
                        return `<li>${id} (${errors.join('; ')})</li>`
                    }
                    return `<li>${id}</li>`
                }).join('')
                msg += `Las siguientes facturas están incompletas: <ul>${detailedIncomplete}</ul><br>`
            }
            //this.screen_data.error_message(msg.trim())
            this.screen_data.setLoading(false)
            //console.log("badDraft", badDraft, "badConfig", badConfig, "badIncomplete", badIncomplete, "badPaymentMeans", badPaymentMeans, "badDueDate", badDueDate)
            return { error: true, message: msg.trim(), badPaymentMeans, badDueDate}
        }
        
        //arribats aquí és que podem procedir a signar-les.
        try {
            res = await this.invoice_repo.massive_sign(ids)
            this.screen_data.asyncJobState = 'running'
            this.screen_data.asyncJobId = res.job_id
            return { error: false, job_id: res.job_id, success: true}
        } catch (e) {
            return { error: true, message: 'Error al firmar facturas' }
        } finally {
            this.screen_data.setLoading(false)
            // this.screen_data.dueDate=''
            // this.screen_data.paymentMeans=''
        }       
        
    }

    setCurrentCompanyDB(currentCompany){
        this.screen_data.companydb.configuration = {
            auto_send_to_verifactu: currentCompany.configuration.auto_send_to_verifactu,
            sii_opt_checked: currentCompany.configuration.sii_opt_checked,
            spanish_territory_opt_checked: currentCompany.configuration.spanish_territory_opt_checked,
            no_application_checked: currentCompany.configuration.no_application_checked,
            company_as_party: {
                type: currentCompany.configuration.company_as_party?currentCompany.configuration.company_as_party.type:null,
            },
        }
        this.screen_data.companydbLoaded = true
    }

    hasAccessToFacturaE(){
        // Si los datos de la compañía aún no se han cargado, permitir acceso (no mostrar popup)
        if (!this.screen_data.companydbLoaded){
            return true
        }
        if (!this.screen_data.companydb ||!this.screen_data.companydb.configuration){
            return true
        }
        let configuration = this.screen_data.companydb.configuration
        let has_any_checkbox_selected = configuration.auto_send_to_verifactu || configuration.sii_opt_checked || configuration.spanish_territory_opt_checked || configuration.no_application_checked

        if(!configuration.company_as_party && !configuration.company_as_party.type){
            return true
        }

        let type = configuration.company_as_party.type?configuration.company_as_party.type:'juridica' 
        
        let deadline_for_juridica_businesses = new Date(2027, 0, 1)
        let deadline_for_fisica_businesses = new Date(2027, 5, 1)

        if (this.screen_data.today>=deadline_for_juridica_businesses && type == 'juridica' && !has_any_checkbox_selected || this.screen_data.today>=deadline_for_fisica_businesses && type == 'fisica' && !has_any_checkbox_selected){
            return false
        }
        return true
    }

    shouldShowSequence2026Popup(currentCompany: any): boolean {
        if (this.invoiceable_type === 'proforma') {
            return false
        }
        if (currentCompany && currentCompany.configuration && currentCompany.configuration.already_shown_popup_sequence_2026) {
            return false
        }
        return true
    }

    async dismissSequence2026Popup(companydb_id: number, currentCompany: any): Promise<boolean> {
        try {
            await this.config_repo.update_companydb_configuration_flag(
                companydb_id,
                'already_shown_popup_sequence_2026',
                true
            )
            if (currentCompany) {
                currentCompany.configuration.already_shown_popup_sequence_2026 = true
            }
            return true
        } catch (error) {
            console.error('Error saving popup preference:', error)
            return false
        }
    }

    async massiveSignToDraft(delete_invoice_number: boolean = false){
        this.screen_data.setLoading(true)
        let res;
        try {
            let ids = this.screen_data.selectedItems.map(item => item['id'])
            res = await this.invoice_repo.massive_sign_to_draft(ids, delete_invoice_number)
        } catch (e) {
            return { error: true, message: 'Error al pasar las facturas a borrador' }
        } finally {
            this.screen_data.setLoading(false)
        }
        return res
    }
}